import createPalette from '@material-ui/core/styles/createPalette'

const palette = createPalette({
  primary: {
    main: '#973695',
    light: 'rgba(151, 54, 149, 0.1)'
  },
  secondary: {
    main: '#FAFAFA'
  },
  text: {
    primary: '#595959',
    secondary: '#333333'
    // disabled: '#D4DAE1',
    // hint: '#BFBFBF'
  },
  info: {
    main: '#FFD7D8',
    light: '#E5EFFC',
    dark: '#D83732'
  },
  success: {
    main: '#CEFFDF',
    dark: '#0EBA48',
    light: '#f44336'
  },
  warning: {
    main: '#FF9824'
  },
  grey: {
    '300': '#BFBFBF',
    '200': '#E1E6E8',
    '100': '#E9EFF7'
  },
  common: {
    white: '#FFF',
    black: '#000'
  },
  background: {
    default: '#F6F8F9'
  },
  bg: {
    headerBg: '#fff',
    footerBg: '#fff'
  }
})

export default palette
